import { BObject } from "../Objects/BObject";
import { BMotionObject } from '../Objects/BMotionObject';
import { bezieApp } from "../main";
import { BImage } from "../Objects/BImage";
import { BMotionType } from "../Animations/BMotionEnums";
import { UIUpdate } from "./UIUpdate";
import { ObjectPropertyUI } from "./ObjectPropertyUI";
import { BText } from '../Objects/BText';
import { ShapeType, BShape } from '../Objects/Shapes/BShape';
import { BCircle } from '../Objects/Shapes/BCircle';
import { BRect } from '../Objects/Shapes/BRect';
import { BVectorBuilder } from '../Objects/ObjectConstructors/BVectorBuilder';
import { BVectorBuilder2 } from "../Objects/ObjectConstructors/BVectorBuilder2";

export module UIEvents{
    //var assetThumbNailDim = 64;
    
    /*
    export function initEvents(){
        $(document).ready(onDocumentReady);
    }

    function onDocumentReady(){
        ($('.menu .item') as any).tab(); //for semantic ui tabs
				
        $("#btnFileUpload").click(function() {
            $("#ipLoadImage").click();
        });
        
        $("#ipLoadImage").on("change", loadImage);

        $("#prop-addMotionBtn").click(function(){
            ($('.ui.modal.motionSelection') as any).modal('show');
            //($('#prop-motionSelection') as any).modal('show');
        });

        //Setting up playback slider
        ($('#playback-range') as any).range({
            min: 0,
            max: 239,
            start: 0,
            onChange: function(value : any, meta : any) {
                if(meta.triggeredByUser) {
                    // now you can run code that will call `set value`
                    onUserSelectFrame(value);
                }
                $('#playback-frame').html(value + " of " + bezieApp.getScene().getTotalFrames());
            }
          });
    }*/

    
    /*export function loadImage(event : Event){
        for(let file of (event as any).target.files){
            var fileReader;
            fileReader = new FileReader;
            console.log("load image");
            fileReader.onload = function(eventb : Event) {
                console.log("on load");
                var img = $('<img>'); 
                img.attr("width", assetThumbNailDim);
                img.attr("height", assetThumbNailDim);
                img.attr("style", "margin:5px;");
                img.attr("draggable", "true");
                img.attr("ondragstart", "UIEvents.drag(event)");
                img.attr("onclick", "UIEvents.addImageToCanvas(event)");
                img.attr("src", (eventb as any).target.result);
                $("#assetThumbnails").append(img);
                console.log("loaded");
            };
            
            fileReader.readAsDataURL(file);
        }
    }*/
    

    /*export function onImageDrag(event:Event){
        (event as any).dataTransfer.setData("uri", (event as any).target.src);
        console.log("on drag "+(event as any).target.src);
    }*/

    export function addImageToCanvas(imgSrc: string){
        if(bezieApp && imgSrc){
            console.log("on image click. adding to canvas.");
            let imageObj = new BImage([bezieApp.getDimension()[0]/2, bezieApp.getDimension()[1]/2], imgSrc, bezieApp.getScene().getFrameRange(), bezieApp.getDimension());
            bezieApp.addBObjectToScene(imageObj);
        }
    }

    export function addTextToCanvas(text: string, font: string){
        if(bezieApp && text){
            console.log("adding text to canvas");
            let textObj = new BText([bezieApp.getDimension()[0]/2, bezieApp.getDimension()[1]/2], text, bezieApp.getScene().getFrameRange(), font);
            bezieApp.addBObjectToScene(textObj);
        }
    }

    export function addShapeToCanvas(type: ShapeType){
        if(bezieApp && type!=null){
            console.log("adding shape of type "+type);
            if(type == ShapeType.CIRCLE){
                let shape = new BCircle([bezieApp.getDimension()[0]/2, bezieApp.getDimension()[1]/2], 50, bezieApp.getScene().getFrameRange())
                bezieApp.addBObjectToScene(shape);
            } else if(type == ShapeType.RECTANGLE){
                let shape = new BRect([bezieApp.getDimension()[0]/2, bezieApp.getDimension()[1]/2], [100,50], bezieApp.getScene().getFrameRange())
                bezieApp.addBObjectToScene(shape);
            } else if(type == ShapeType.VECTOR){
                new BVectorBuilder(bezieApp.getDimension(), bezieApp.getScene(), bezieApp.getInputHandler()).startConstruction();
                //new BVectorBuilder2(bezieApp.getScene(), bezieApp.getInputHandler()).startBuilding();
            } else{
                console.log("invalid shape type");
            }
        }
    }

    export function playOrPause(){
        if(bezieApp){
            bezieApp.playOrPause();
            UIUpdate.updatePlayPauseBtn();
        }
    }

    export function stop(){
        if(bezieApp){
            bezieApp.stop();
            UIUpdate.updatePlayPauseBtn();
        }
    }

    /*export function addMotion(type : BMotionType){
        if(bezieApp){
            let selObj = bezieApp.getScene().getSelectedObject();
            if(selObj!=null && selObj.isMotionObject()){
                (selObj as BMotionObject).addMotionWithDefaultValues(type);
                UIUpdate.updatePropertiesUI(selObj);
            }
        }
    }*/

    export function saveAsGif(gif: any){
        if(bezieApp){
            //($('.ui.modal.saveDialog') as any).modal('show');
            bezieApp.saveAsGif(gif);
            //$('body').bind('DOMNodeInserted', updateSaveToGifDialog);
        }
    }

    export function saveAs(type: string){
        if(bezieApp){
            bezieApp.saveAs(type);
        }
    }

    function updateSaveToGifDialog(){
        if($("a:last")){ //hyperlink to blob would be attached at the end of doc by CCapture lib upon creating gif.
            $('body').unbind('DOMNodeInserted');
            ($('.ui.modal.saveDialog') as any).modal('hide');
            /*
            $("#save-dialog-processing-loader").hide();
            $("a:last").html("").removeAttr('style');
            $("#save-dialog-downloadBtn").css('visibility','visible').appendTo($("a:last"))
            $("a:last").appendTo($("#save-dialog-anchor"));*/
        }
    }

    export function deleteObject(){
        if(bezieApp){
            bezieApp.getScene().deleteSelectedObject();
        }
    }

    /*export function deleteMotion(motionId : string){
        if(bezieApp){
            let obj = bezieApp.getScene().getSelectedObject();
            if(obj && obj.isMotionObject()){
                (obj as BMotionObject).deleteMotion(motionId);
                UIUpdate.removeMotionPropertyUI(motionId);
                //UIUpdate.updatePropertiesUI(app.getScene().getSelectedObject());
            }
        }
    }*/

    export function setFrameRangeOfSelObj(){
        if(bezieApp){
            let obj = bezieApp.getScene().getSelectedObject();
            if(obj){
                //TODO
            }
        }
    }

    export function moveSelObjByALayer(forward : boolean){
        if(bezieApp){
            let obj = bezieApp.getScene().moveSelectedObjectByALayer(forward);
        }
    }

    export function onPropertyInputValueChange(elementId : string, value : string){
        if(bezieApp){
            let obj = bezieApp.getScene().getSelectedObject();
            if(obj){
                ObjectPropertyUI.handleUIInput(obj, elementId, value);
            }
        }
    }

    /*export function onBMotionInputValueChange(elementId: String, motionId : String, label : String){
        if(bezieApp){
            let obj = bezieApp.getScene().getSelectedObject();
            if(obj && obj.isMotionObject()){
                var value = $('#'+elementId).val();
                if(Number(value)!=NaN){
                    console.debug("BMotion Input value change: " + value as String + " motionId:"+motionId+ " eleId:"+elementId);
                    (obj as BMotionObject).updateMotion(motionId, label, value);
                }
            }
        }
    }*/

    function onUserSelectFrame(value : any){
        if(Number(value)!=NaN){
            if(bezieApp){
                bezieApp.getScene().setCurFrame(value);
            }
        }
    }

    export function duplicate(){
        if(bezieApp){
            bezieApp.getScene().duplicateSelectedObject();
        }
    }

    /*export function addSource(){
        if(bezieApp){
            var  type = new Array<BObject>();
            type.push(bezieApp.getScene().sceneObjects[0]); //Todo do check
            bezieApp.getScene().addBObject(
                new BSource([bezieApp.width/2, bezieApp.height/2], bezieApp.getScene().getFrameRange(), 10, type)
            );
        }
    }*/
}